import Sentry from '@collector/shared-plugin-sentry-vue'
import { isInternetDisconnectedError } from '@collector/shared-utils'
import { ApiClient, Season, SportId } from '@collector/sportsapi-client-legacy'
import { AppDatabase } from '@mobile/database/AppDatabase'
import * as app from '@mobile/globalState/app'

const sportIds: SportId[] = [
  SportId.Soccer,
  SportId.Handball,
  SportId.Cricket,
  SportId.Volleyball,
  SportId.Basketball,
  SportId.BeachVolleyball,
  SportId.AmericanFootball,
  SportId.Basketball3x3,
  SportId.IceHockey,
]

export interface UseSportSynchronizer {
  synchronizeSport: (sportId: SportId, seasonId?: Season['id']) => Promise<void>
  synchronizeSports: () => Promise<void>
}

export function useSportsSynchronizer(
  apiClient: ApiClient,
  database: AppDatabase,
): UseSportSynchronizer {
  async function synchronizeSports(): Promise<void> {
    for (const sportId of sportIds) {
      await synchronizeSport(sportId)
    }
  }

  async function synchronizeSport(
    sportId: SportId,
    seasonId?: Season['id'],
  ): Promise<void> {
    try {
      const response = await apiClient.getSport(sportId, seasonId)
      const sport = response.api.data.sport

      await database.sports.put(sport)
      app.putSport(sport)

      return
    } catch (error) {
      if (!isInternetDisconnectedError(error)) {
        Sentry.captureException(error)
      }
    }

    const sport = await database.sports.getBySportId(sportId)

    if (!sport) {
      throw new Error(
        `Local database doesn't contain definitions for sport: ${sportId}`,
      )
    }

    app.putSport(sport)
  }

  return { synchronizeSport, synchronizeSports }
}
